import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-report-header-buttons',
  templateUrl: './report-header-buttons.component.html',
  styleUrls: ['./report-header-buttons.component.css'],
  standalone: false
})
export class ReportHeaderButtonsComponent implements OnInit {
  @Input() vm: any;

  @Input() buttonConfig: any;

  @Output() updateEmit = new EventEmitter<string>();
  @Output() setReportDataEmit = new EventEmitter<string>();
  @Output() clearEmit = new EventEmitter<string>();
  @Output() closeEmit = new EventEmitter<string>();
  @Output() exportToExcelEmit = new EventEmitter<string>();
  @Output() reportFormatEmit = new EventEmitter<string>();
  @Output() printReportEmit = new EventEmitter<string>();
  @Output() emailEmit = new EventEmitter<string>();
  @Output() resetEmit = new EventEmitter<string>();

  public submitted = false;

  buttons: any = {
    filters: true,
    clear: true,
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    // When true (default), actions are disabled if vm.report is empty/undefined
    disableOnEmpty: true,
    reset: false,
  };

  constructor() {
  }

  ngOnInit() {
    // Merge provided config with defaults so unspecified buttons default to visible/true
    if (this.buttonConfig) {
      this.buttons = {...this.buttons, ...this.buttonConfig};
    }
  }

  update() {
    this.updateEmit.emit();
  }

  exportToExcel() {
    this.exportToExcelEmit.emit();
  }

  clear() {
    this.vm.monthCount = 0;
    this.clearEmit.emit();
  }

  close() {
    this.vm.monthCount = 0;
    this.closeEmit.emit();
  }

  printReport() {
    this.printReportEmit.emit();
  }

  email() {
    return this.emailEmit.emit();
  }

  reset() {
    this.resetEmit.emit();
  }

  setReportData() {
    this.setReportDataEmit.emit();
  }

  reportFormat(event) {
    this.vm.report_format = event;
    this.reportFormatEmit.emit(event);

  }
}
